import BottomSheet from '@components/BottomSheet'
import { ContactList } from '@components/ContactList/ContactList'
import { SidebarMobileToggle } from '@components/Sidebar/MobileToggle'
import ContactForm from '@modules/ContactForm'
import { Contact } from '@plug-core/interfaces/common'
import { useContacts } from '@plug-core/state'
import { Button } from '@ui'
import { ROUTES } from '@utils/routes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HiUserAdd } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'

export const Contacts = () => {
  const { contacts } = useContacts()
  const [contactModalVisible, setContactModalVisible] = useState(false)
  const navigate = useNavigate()
  const { t } = useTranslation()

  const navigateToContact = ({ id }: Pick<Contact, 'id'>) => {
    navigate(ROUTES.CONTACT_DETAILS(id), { state: { id } })
  }

  return (
    <div className="mb-3 flex flex-col">
      <SidebarMobileToggle title="Contacts" />

      <ContactList contacts={contacts} onContactClick={navigateToContact} />

      <Button
        variant="ghost"
        onClick={() => setContactModalVisible(true)}
        startIcon={<HiUserAdd aria-hidden />}
        fullWidth
        className="mt-2"
      >
        {t('contacts.addNew')}
      </Button>

      <BottomSheet
        visible={contactModalVisible}
        onBackdropClick={() => setContactModalVisible(false)}
      >
        <ContactForm
          close={() => setContactModalVisible(false)}
          onSave={(id) => navigateToContact({ id })}
        />
      </BottomSheet>
    </div>
  )
}
